import { createReducer } from "@reduxjs/toolkit";
import { Movie } from "../../models/paginatedMovie.model";
import { movieDetailsThunk } from "./details-thunk";

export interface MovieDetailsState {
  status: "idle" | "loading" | "failed";
  value: Movie | null;
}

const initialState: MovieDetailsState = {
  status: "idle",
  value: null,
};

export const MovieDetailsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(movieDetailsThunk.pending, (state) => {
      state.status = "loading";
    })
    .addCase(movieDetailsThunk.fulfilled, (state, action) => {
      state.status = "idle";
      state.value = action.payload;
    })
    .addDefaultCase((state, action) => {});
});
